<div class="ui-g-11 control-wrapper">
  <label class="mr-1" *ngIf="isRequired" [ngClass]="{ required: isRequired }"></label>
  <p-checkbox
    appEnterClick
    [label]="label"
    [binary]="binary"
    (onChange)="selectValue($event)"
    [(ngModel)]="selectedValue"
    [disabled]="control.disabled || forceDisable"></p-checkbox>
</div>
